import styled from "styled-components";

type Props = {
  currency?: string;
  disabled?: boolean;
};

export const WalletSummarySection = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 1rem;
  overflow-x: scroll;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  &::-webkit-scrollbar {
    display: none; 
  }
  @media (max-width: 768px) {
    overflow: scroll;
    gap: 20px;
    margin-top: 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const WalletSummaryCard = styled.button<Props>`
  background-color: #FCFCFC;
  cursor: ${(props) => (props.currency === "GBP" || props.disabled ? "not-allowed" : "pointer")};
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  min-width: 214px;
  height: 128px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 16px;
  color: #000000;

  h4 {
    font-family: "Suisse International", sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    line-height: 32px;
    letter-spacing: -0.4px;
    margin: 0;
    text-align: left;
  }

  p {
    margin: 0;
    display: flex;
    align-items: center;
    font-family: "Inter";
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  &:hover {
    color: #000000;
  }
`;